// Styling
import style from "./layout-column.module.scss";

export default function LayoutColumn({ columnAttributes, columnStyleItems, location, children }) {

  // --- Define Variables --- //
  const colHoriOrientation = columnAttributes?.colHori ?? "center";
  const colVertOrientation = columnAttributes?.colVert ?? "center";
  const colContentOrientation = columnAttributes?.content ?? "horizontal";
  const colCount = columnStyleItems?.colCount ?? 1;

  const bpMD = columnStyleItems?.breakpoints.md ?? "800";
  const bpLG = columnStyleItems?.breakpoints.lg ?? "992";

  const layoutType = columnStyleItems?.layoutType ?? "flex";
  const colSizes = columnStyleItems?.layoutType === "flex" ? columnStyleItems?.colFlex : columnStyleItems?.colGrid;
  const breakpointSizes = ["", "lg", "md", "mdlg"];
  let layoutLocation = location ?? 'empty';

  // --- Define Breakpoints --- //
  var styleByLayout = ``;

  function generateColumnStyle(layout, styleVal, bp) {
    var styleItem = "";
    var stylePart = "";
    // Style
    if (styleVal === "none") {
      stylePart = "display: none;";
    } else if (styleVal === "auto" && layout === "flex") {
      stylePart = "display: flex; flex: auto;";
    } else {
      if (layout === "flex") { stylePart = "display: flex; flex: 0 0 " + styleVal + ";"; }
      else if (layout === "grid") { stylePart = "display: flex; grid-column: span " + styleVal + ";"; }
    }
    // Breakpoints
    if        ( bp === 'lg' )   { styleItem = '@media( min-width: ' + bpLG + 'px ) { ' + stylePart + '}'; }
    else if   ( bp === 'md' )   { styleItem = '@media( max-width: ' + bpMD + 'px ) { ' + stylePart + '}'; }
    else if   ( bp === 'mdlg' ) { styleItem = '@media( min-width: ' + (parseInt(bpMD) + 1) + 'px ) and ( max-width: ' + (parseInt(bpLG) - 1) + 'px ) { ' + stylePart + '}'; }
    else      { styleItem = stylePart; }
    return styleItem;
  }

  if( layoutType ) {
    breakpointSizes.map((size, index) => {
      if( colSizes[index] ) {
        styleByLayout += generateColumnStyle( layoutType, colSizes[index], size );
      }
    });
  }
  const columnStyle = `
    .${layoutLocation}LayoutColumn${colCount} {
      display: flex;
      flex-wrap: wrap;
      ${styleByLayout}
    }
  `;

  return (
    <div
      className={`${style.layoutColumn} ${layoutLocation}LayoutColumn${colCount}`}
      col-hori={colHoriOrientation}
      col-vert={colVertOrientation}
      content={colContentOrientation}
    >
      <style jsx>{`
        ${columnStyle}
      `}</style>

      {children}
    </div>
  );
}